<template xmlns="http://www.w3.org/1999/html">
    <div>
           <h4>Choose from the list below and upload your selfie.</h4><br>
        <h2>{{ step.title }}</h2>
        <p class="step__notice">
            All fields with an asterisk are required
            <i class="fas fa-asterisk"></i>
        </p>
        <h4>Remember, your photo must be:</h4><br>
        <ul>
            <li>Of an authentic and original ID document (not a copy of one)</li>
            <li>Clear and in focus (so that the information on your document is readable)</li>
            <li>In colour</li>
            <li>Unaltered by computer software in any way</li>
        </ul><br>
         <h4>Your selfie must:</h4><br>
        <ul>
            <li>Show your document in full (so that the information on it is readable)</li>
            <li>Not cut out any part of your head or document from the photo</li>
            <li>Not include a head or face covering (unless it’s for religious or medical reasons)</li>
            <li>Not have anything else covering your face or eyes e.g. such as hair or shadows</li>
        </ul><br>
          <img src="https://images.ctfassets.net/2tjc93jinw29/15BIGmzbWvJXfRKLwIW40v/278594540bd4c651ecb4f8a161046723/Selfie_Images_Examples.jpg?h=600" alt="" class="responsive">

        <InputRadioGroup
            name="Selfie"
        >
            <template v-slot:question>
                {{ getField("Selfie").question }}
            </template>
        </InputRadioGroup>

        <InputFile
            @input="handleFileInput"
            :error="formRef.errors.get('file')"
            accept="image/jpeg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.oasis.opendocument.text"
        />
    </div>
</template>

<script setup>
import InputRadioGroup from "../Form/InputRadioGroup.vue";
import Form from "../../../js/Form";
import InputFile from "../Form/InputFile.vue";
import { ref, markRaw } from "vue";

const props = defineProps({
    step: Object,
    fields: Object,
    formData: Object
})

let formRef = markRaw(ref(new Form({
    file: null
}, {...props.formData})))

const getField = (fieldName) => {
   return props.fields[fieldName];
}

function handleFileInput(e) {
    formRef.value.file = e;
}

defineExpose({
    formRef
})
</script>

<style scoped>
.responsive {
  width: 100%;
  height: auto;
  margin-bottom: 10%;
}
</style>

